<template>
  <!-- <component :is="activeModal" :key="modalPath" :v-if="activeModal"></component> -->
  <div v-for="modal in modals" :key="modal.label" class="mod">
    <a class="menua" @click="toggleModal(modal.label, title)">{{
      modal.label
    }}</a>
    <base-modal :name="modal.label" :class="title" :title="title">
      <component :is="getModuleComponent(modal.path)" />
    </base-modal>
  </div>
</template>

<script lang="ts" setup>
import { Modal } from "@/models/Modal";
import useModal from "@/hooks/useModal";
import modalComponents from "@/views/modals/context/index";
import BaseModal from "@/views/modals/BaseModal.vue";
import { ref, PropType, Component } from "vue";

const props = defineProps({
  modals: {
    type: Array as PropType<Modal[]>,
    default: () => [],
  },
  title: {
    type: String,
    default: "",
  },
});

const modalPath = ref("");
const activeModal = ref();
const { toggleModal } = useModal();
// const activeModal = computed(() => {
//   if (modalPath.value) {
//     const modalComp = defineAsyncComponent(
//       () => import(`@/views/modals/${modalPath.value}`)
//     );
//     return modalComp;
//   }
//   return null;
// });
// const activeModal = defineAsyncComponent(
//   () => import("../modals/HiTest.vue")
// );

// const importModal = (modal: string) => {
//   return defineAsyncComponent(
//     () => import(`@/views/modals/${modalPath.value}`)
//   );
// return () => import(`@/views/modals/HiTest.vue`);
//};
// const importModal = (modal: string) => {

// };
// const showCovered = (modalName: string) => {
// modalPath.value = modalPathE;
// activeModal.value = importModal(modalPathE);
// console.log(activeModal.value);
// };
// const mods = props.modals.filter((item) => {
//   return (item.label = item.label + props.title);
// });
// console.log(props);
const getModuleComponent = (path: string): Component | null => {
  const module: { name: string; component: Component } | undefined =
    modalComponents.find((e: { name: string; component: Component }) =>
      path.includes(e.name)
    );
  return module?.component ? module.component : null;
};
</script>
